import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'removeStoryTitle' })
export class RemoveStoryTitlePipe implements PipeTransform {
  private domparser = new DOMParser();

  transform(storyHTML: string | undefined | null): string | undefined | null {
    if (storyHTML === undefined || storyHTML === null) return storyHTML;

    const domDoc = this.domparser.parseFromString(storyHTML, 'text/html');

    let story = storyHTML;

    /* Remove title from story */
    if (domDoc.getElementsByTagName('h1').length > 0) {
      story = story.replace(domDoc.getElementsByTagName('h1')[0].outerHTML, '');
    }

    return story;
  }

}
